import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  WorkloadAssignment,
  ScanningContainer,
  WorkloadMetrics,
  CreateAssignmentRequest,
  SelfAssignRequest,
  UpdateAssignmentRequest,
  WorkloadListParams,
  ReceivingListParams
} from '../types';

const { HANDOVER_SCANNING } = API_ENDPOINTS;

export const handoverScanningApi = {
  getAll: (params?: WorkloadListParams) =>
    apiClient.getPaginated<WorkloadAssignment>(HANDOVER_SCANNING.LIST, params),

  getOne: (id: number) =>
    apiClient.get<WorkloadAssignment>(HANDOVER_SCANNING.SHOW(id)),

  create: (data: CreateAssignmentRequest) =>
    apiClient.post<WorkloadAssignment[]>(HANDOVER_SCANNING.CREATE, data),

  selfAssign: (data: SelfAssignRequest) =>
    apiClient.post<WorkloadAssignment[]>(HANDOVER_SCANNING.SELF_ASSIGN, data),

  update: (id: number, data: UpdateAssignmentRequest) =>
    apiClient.put<WorkloadAssignment>(HANDOVER_SCANNING.UPDATE(id), data),

  delete: (id: number) => apiClient.delete(HANDOVER_SCANNING.DELETE(id)),

  getMetrics: () => apiClient.get<WorkloadMetrics>(HANDOVER_SCANNING.METRICS),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<WorkloadListParams> }
  ) => apiClient.post(HANDOVER_SCANNING.BULK_DELETE, params),

  getReceivingList: (params?: ReceivingListParams) =>
    apiClient.getPaginated<ScanningContainer>(
      HANDOVER_SCANNING.RECEIVING_LIST,
      params
    )
};
